import React from "react";

import { isEmpty } from "lodash/fp";

import useTranscriptStore from "@app/analytics/MeetingReport/stores/transcript";

import TranscriptFiltersButtonAndMenu from "./TranscriptFiltersButtonAndMenu";
import TranscriptFiltersDialog from "./TranscriptFiltersDialog";

const TranscriptFilters = ({ variant }: { variant: "menu" | "dialog" }) => {
  const {
    allSpeakers,
    filteredSpeakers,
    setFilteredSpeakers,
    transcriptAvailable,
  } = useTranscriptStore((state) => ({
    allSpeakers: state.allSpeakers,
    filteredSpeakers: state.filteredSpeakers,
    setFilteredSpeakers: state.setFilteredSpeakers,
    transcriptAvailable: state.transcriptAvailable,
  }));

  if (isEmpty(allSpeakers) || !transcriptAvailable) return null;

  const handleClearFilters = () => setFilteredSpeakers(allSpeakers);

  const filterCount = allSpeakers.length - filteredSpeakers.length;

  if (variant === "menu") {
    return (
      <TranscriptFiltersButtonAndMenu
        filterCount={filterCount}
        onClearFilters={handleClearFilters}
      />
    );
  }

  return <TranscriptFiltersDialog />;
};

export default TranscriptFilters;
